export default {
    videos: 'Videos',
    data_consumed: 'Datos consumidos (mb)',
    size: 'Tamaño (Mb)',
    lms_link: 'LMS Link',
    video: 'Video',
    no_file: 'No hay ningún archivo',
    text_upload_file: 'Empieza subiendo un nuevo archivo.',
    upload: 'Subir',
    quota_label: 'Espacio usado',
    quota_of: '{used} de {limit}',
    quota_none: 'Tu plan no incluye espacio de almacenamiento: no se pueden subir vídeos. Amplía el plan para poder subirlos.',
    quota_full: 'Has llenado el espacio de tu plan. Vacía la papelera o amplía el plan para subir más vídeos.',
    quota_exceeded: 'El vídeo ocupa {size} y solo quedan {free} libres en tu plan. Vacía la papelera o amplía el plan.',
}